import {MediumPrimaryButton} from "@worthy-npm/clarity"
export default MediumPrimaryButton
